import React, { useState } from 'react';
import PlusIcon from 'assets/images/Ticketing-Plus-Coral.svg';
import MinusIcon from 'assets/images/Ticketing-Minus-Coral.svg';
import { FNB_PDF_URL } from 'config/env';
import styles from "./style.scss";

export const FnBSelection = (props) => {
  const { fnbPackages, onPackageChange, selectedPackages: externalSelectedPackages , maxQuantityPerPackage = 30 } = props;

  const [internalSelectedPackages, setInternalSelectedPackages] = useState({});
  const [pdfOverlay, setPdfOverlay] = useState(null);
  const selectedPackages = externalSelectedPackages || internalSelectedPackages;
  const setSelectedPackages = onPackageChange || setInternalSelectedPackages;

  const getPackageQuantity = (packageId) => selectedPackages[packageId]?.quantity || 0;

  const openMenuLink = (e, link) => {
    e.stopPropagation();
    setPdfOverlay(link);
  }

  const handleQuantityChange = (pkg, change) => {
    setSelectedPackages(prev => {
      const currentQuantity = prev[pkg.id]?.quantity || 0;
      const newQuantity = Math.max(0, Math.min(maxQuantityPerPackage, currentQuantity + change));

      if(newQuantity === 0) {
        const { [pkg.id]: removed, ...rest } = prev;
        return rest;
      }

      return {
        ...prev,
        [pkg.id]: {
          ...pkg,
          quantity: newQuantity
        }
      }
    })
  }

  return (
     <div className='fnb-container'>
      <div className='fnb-header'>
        <h3 className='fnb-title'>Food & Beverages <span>(per person)</span></h3>
      </div>

      <div className='fnb-packages'>
        {fnbPackages.length > 0 && 
          fnbPackages.map((pkg) => {
              const packageQuatity = getPackageQuantity(pkg.id);
              const isSelected = packageQuatity > 0;

              return (
                <div key={pkg.id} className={`fnb-package-box ${isSelected ? 'selected' : ''}`}>
                  <div className='package-content'>
                    <div className='package-info'>
                      <h4 className='package-name'>{pkg.name}</h4>
                    </div>
                    <div className='package-menu'>
                        {pkg.catalogue_link && (
                          <button className='menu-link' onClick={(e) => openMenuLink(e, FNB_PDF_URL + pkg.catalogue_link)}>Menu</button>
                        )}
                    </div>
                    <div className='package-actions'>
                        <div className='package-price'>₹ {pkg.price} + 5% GST</div>
                        <div className='package-controls'>
                          <button
                            className='control-btn minus'
                            onClick={() => handleQuantityChange(pkg, - 1)}
                            disabled= {packageQuatity === 0}
                            type='button'
                          >
                            <img src={MinusIcon} alt={'decrement-icon'}/>
                          </button>
                          <span className='quantity'>{packageQuatity}</span>
                          <button
                            className='control-btn plus'
                            onClick={() => handleQuantityChange(pkg, 1)}
                            disabled= {packageQuatity >= maxQuantityPerPackage}
                            type='button'
                          >
                            <img src={PlusIcon} alt={'increment-icon'}/>
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              )
          })
        }
      </div>

      {pdfOverlay && (
        <div className="pdf-overlay">
          <div className="pdf-content">
            <button className="close-btn" onClick={() => setPdfOverlay(null)}>✕</button>
            <iframe src={`${pdfOverlay}#toolbar=0`} title="Menu PDF" className="pdf-frame" />
          </div>
        </div>
      )}
    </div>
  )
};
